"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatesOfDateRange = void 0;
const moment_1 = __importDefault(require("moment"));
const getDatesOfDateRange = (dateRange) => {
    const dates = [];
    let dateFrom = dateRange.from;
    do {
        dates.push(dateFrom);
        dateFrom = (0, moment_1.default)(dateFrom).add(1, "d").format("YYYY-MM-DD");
    } while ((0, moment_1.default)(dateRange.to).isSameOrAfter(dateFrom));
    return dates;
};
exports.getDatesOfDateRange = getDatesOfDateRange;
//# sourceMappingURL=getDatesOfDateRange.js.map